import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "webform/store/store";

export const configSelector = (state: RootState) => state.config;
export const configErrorSelector = createSelector(configSelector, ({error}) => error);
export const localeSelector = createSelector(configSelector, ({locale}) => locale);
export const isWebformAvailableSelector = createSelector(configSelector, ({isAvailable}) => isAvailable);
export const userInformationSelector = createSelector(configSelector, ({userInformation}) => userInformation);
export const isWebformAvailableLoadingSelector = createSelector(configSelector, ({isLoading}) => isLoading);
